export const version = "a0.0.1";
export const g = 1.5; // m/s^2
